import { message } from "antd";
import axios from "axios";

export const getProducts = () => (dispatch) => {
  axios
    .get("https://mkart-frontend.herokuapp.com/api/v1/products")
    .then((response) => {
      dispatch({ type: "SET_PRODUCTS", payload: response.data });
      dispatch({ type: "SET_FILTER_PRODUCTS", payload: response.data });
    })
    .catch((err) => {
      console.log(err.response);
    });
};

export const filterProducts = (search, products) => (dispatch) => {
  const data = products.filter((product) => {
    return product.name.toLowerCase().match(search.toLowerCase());
  });
  dispatch({ type: "SET_FILTER_PRODUCTS", payload: data });
};

export const getCarts = () => (dispatch) => {
  axios
    .get(`https://mkart-frontend.herokuapp.com/api/v1/cart`)
    .then((response) => {
      dispatch({ type: "SET_CARTS", payload: response.data });
    })
    .catch((err) => {
      console.log(err.response);
    });
};

export const setCarts = (info, type) => (dispatch) => {
  axios
    .post("https://mkart-frontend.herokuapp.com/api/v1/cart", info)
    .then(() => {
      dispatch(getCarts());
      if (type === "add") {
        message.success("Product added to cart successfully!!!");
      } else {
        if (Number(info.qty) === 0) {
          message.success("Product removed from the cart successfully!!!");
          dispatch(getProducts());
        } else {
          message.success("Product cart updated successfully!!!");
        }
      }
    })
    .catch((err) => {
      console.log(err.response);
    });
};

export const getAddress = () => (dispatch) => {
  axios
    .get("https://mkart-frontend.herokuapp.com/api/v1/user/addresses")
    .then((response) => {
      dispatch({ type: "SET_ADDRESS", payload: response.data });
    })
    .catch((err) => {
      console.log(err.response);
    });
};

export const addAddress = (data) => (dispatch) => {
  axios
    .post("https://mkart-frontend.herokuapp.com/api/v1/user/addresses", data)
    .then(() => {
      dispatch(getAddress());
      message.success("Address added successfully!!!");
    })
    .catch(() => {
      message.error("Address should be greater than 20 characters..!");
    });
};

export const setCheckout = (id, history) => (dispatch) => {
  axios
    .post("https://mkart-frontend.herokuapp.com/api/v1/cart/checkout", {
      addressId: id,
    })
    .then(() => {
      history.push("thank-you");
    })
    .catch(() => {
      message.error("Cart is empty..please add address..!!");
    });
};

export const deleteAddress = (id) => (dispatch) => {
  axios
    .delete(`https://mkart-frontend.herokuapp.com/api/v1/user/addresses/${id}`)
    .then(() => {
      dispatch(getAddress());
      message.success("Address Deleted successfully!!!");
    })
    .catch((err) => {
      console.log(err.response);
    });
};
